<template>
  <div id="myaccount">
    <div class="rechage_wrapper">
      <!-- <div class="header_wrapper">
        <div class="header_info">
          <el-row>
            <el-col :span="2">
              
            </el-col>
            <el-col :span="22">
              <div class="header_right content-flex">
                <p class="center-nickname">您好,凤凰证券会员</p>
                <i class="line"></i>
                <p class="last-time">用户名： {{ phone }} |  上次登陆时间：{{ time }}</p>
              </div>
            </el-col>
          </el-row>
        </div>
      </div> -->
      <div class="recharge_content">
        <ul class="recharge_right">
          <div class="basicInfo-box">
            <div class="portrait">
              <!-- <el-avatar src="../assets/img/portrait.png" :size="80"></el-avatar> -->
              <img width="80px" src="../assets/img/portrait.png" />
            </div>
            <div class="center-nickname">{{ $t('myAccountPc.greetingMessage', {
                  companyName:
                    $t('myAccountPc.securityNum')
                }) }}</div>
            <div class="last-time">
              {{ $t('myAccountPc.username') }}: {{ username }} | {{
                      $t('myAccountPc.lastLoginTime')
                    }}:{{ time }}
            </div>
          </div>

          <div class="nav-tabs">
            <li
              @click="changeAccount(1)"
              style="text-align: left; padding-left: 35px; line-height: 45px"
              :class="$store.state.accountType == 1 ? 'recharge_li_active' : ''"
            >
              <router-link to="/myaccount/rechange"
                >{{ $t('myAccountPc.myAccount') }}
                <!-- <i class="el-icon-user"></i> -->
              </router-link>
            </li>
            <li
              @click="changeAccount(2)"
              style="text-align: left; padding-left: 35px"
              :class="$store.state.accountType == 2 ? 'recharge_li_active' : ''"
            >
              <router-link to="/myaccount/risk_control"
                >{{ $t('myAccountPc.riskControlNotice') }}
                <!-- <i class="el-icon-warning"></i> -->
              </router-link>
            </li>
            <li v-if="!user_suspect"
              @click="changeAccount(16)" 
              style="text-align: left;cursor: pointer; padding-left: 35px;" 
              :class="$store.state.accountType ==16 ? 'recharge_li_active' : '' "
            >
            <router-link to="">            
              <i class="el-icon-money">Gxpay</i>
</router-link>
            </li>
            <li
              @click="changeAccount(3)"
              style="text-align: left; padding-left: 35px"
              :class="$store.state.accountType == 3 ? 'recharge_li_active' : ''"
            >
              <router-link to="/myaccount/strategynow"
                >{{ $t('myAccountPc.fundingAccount') }}
                <!-- <i class="el-icon-s-data"></i> -->
              </router-link>
            </li>
            <li
              @click="changeAccount(4)"
              style="text-align: left; padding-left: 35px"
              :class="$store.state.accountType == 4 ? 'recharge_li_active' : ''"
            >
              <router-link to="/stockdetailed?symbol=sh000001"
                >{{ $t('account.firmOffer') }}
                <!-- <i class="el-icon-s-marketing"></i> -->
              </router-link>
            </li>
            <li v-if="isSimulate == 0"
              @click="changeAccount(5)"
              style="text-align: left; padding-left: 35px"
              :class="$store.state.accountType == 5 ? 'recharge_li_active' : ''"
            >
              <router-link to="/myaccount/capital"
                >{{ $t('myAccountPc.fundOperation') }}
                <!-- <i class="el-icon-money"></i> -->
              </router-link>
            </li>
            <li
              @click="changeAccount(6)"
              style="text-align: left; padding-left: 35px"
              :class="$store.state.accountType == 6 ? 'recharge_li_active' : ''"
            >
              <router-link to="/myaccount/trading_query"
                >{{ $t('myAccountPc.transactionInquiry') }}
                <!-- <i class="el-icon-s-claim"></i> -->
              </router-link>
            </li>
            <!-- <li
              @click="changeAccount(7)"
              style="text-align: left; padding-left: 35px"
              :class="$store.state.accountType == 7 ? 'recharge_li_active' : ''"
            >
              <router-link to="/myaccount/friend_coupon"
                >{{ $t('myAccountPc.friendCashCoupon') }}
              </router-link>
            </li> -->
            <!-- <li
              @click="changeAccount(8)"
              style="text-align: left; padding-left: 35px"
              :class="$store.state.accountType == 8 ? 'recharge_li_active' : ''"
            >
              <router-link to="/myaccount/usercoupon"
                >{{ $t('myAccountPc.myCashCoupon') }}
              </router-link>
            </li> -->

            <li v-if="haveRedEnvelope==1"
              @click="changeAccount(15)"
              style="text-align: left; padding-left: 35px"
              :class="
                $store.state.accountType == 15 ? 'recharge_li_active' : ''
              "
            >
              <router-link to="/myaccount/red_envelope">
                {{ $t('myAccountPc.redEnvelope') }}
              <!-- <i class="el-icon-suitcase"></i> -->
              </router-link>
            </li>
            <li
              @click="changeAccount(9)"
              style="text-align: left; padding-left: 35px"
              :class="$store.state.accountType == 9 ? 'recharge_li_active' : ''"
            >
              <router-link to="/myaccount/detailed"
                >{{ $t('myAccountPc.fundingDetails') }}
                <!-- <i class="el-icon-s-order"></i> -->
              </router-link>
            </li>
            <li
              @click="changeAccount(10)"
              style="text-align: left; padding-left: 35px"
              :class="
                $store.state.accountType == 10 ? 'recharge_li_active' : ''
              "
            >
              <router-link to="/myaccount/information"
                >{{ $t('myAccountPc.completeMaterial') }}
                <!-- <i class="el-icon-setting"></i> -->
              </router-link>
            </li>
            <li
              @click="changeAccount(11)"
              style="text-align: left; padding-left: 35px"
              :class="
                $store.state.accountType == 11 ? 'recharge_li_active' : ''
              "
            >
              <router-link to="/myaccount/agency"
                >{{ $t('myAccountPc.agencyAccount') }}
                <!-- <i class="el-icon-thumb"></i> -->
              </router-link>
            </li>
            <li
              v-if="financeStatus == 1"
              @click="changeAccount(12)"
              style="text-align: left; padding-left: 35px"
              :class="
                $store.state.accountType == 12 ? 'recharge_li_active' : ''
              "
            >
              <router-link to="/myaccount/finance_fund"
                >{{$t('myAccountPc.regularTreasure')}}
                <!-- <i class="el-icon-suitcase"></i> -->
              </router-link>
            </li>
            <li
              v-if="holidayStatus == 1"
              @click="changeAccount(13)"
              style="text-align: left; padding-left: 35px"
              :class="
                $store.state.accountType == 13 ? 'recharge_li_active' : ''
              "
            >
              <router-link to="/myaccount/holiday_fund">{{ $t('myAccountPc.festivalTreasure') }}
              <!-- <i class="el-icon-suitcase"></i> -->
              </router-link>
            </li>
            <li
              v-if="timebaoStatus == 1 && isSimulate == 0"
              @click="changeAccount(14)"
              style="text-align: left; padding-left: 35px"
              :class="
                $store.state.accountType == 14 ? 'recharge_li_active' : ''
              "
            >
              <router-link to="/myaccount/timebao">{{ $t('myAccountPc.timeTreasure') }}
              <!-- <i class="el-icon-suitcase"></i> -->
              </router-link>
            </li>
            <li style="text-align: left; padding-left: 35px">
              <!-- <i class="el-icon-suitcase"></i> -->
              {{ $t('myAccountPc.versionNumber') }} : {{ version }}
            </li>
          </div>

          <!--          <li @click="changeAccount(12)" :class="$store.state.accountType == 12 ? 'recharge_li_active' : '' ">-->
          <!--            <router-link to="/myaccount/friend_coupon"><i class="el-icon-suitcase"></i>好友现金券</router-link>-->
          <!--          </li>-->
          <!--          <li @click="changeAccount(13)" :class="$store.state.accountType == 13 ? 'recharge_li_active' : '' ">-->
          <!--            <router-link to="/myaccount/usercoupon"><i class="el-icon-suitcase"></i>我的现金券</router-link>-->
          <!--          </li>-->
        </ul>
        <router-view name="kids"></router-view>
      </div>
    </div>
    <keep-alive> </keep-alive>
  </div>
</template>
<script>
import { version } from './../../package.json'
import "./../assets/css/account.css";
import "./../assets/css/deal.css";
export default {
  name: "Myaccount",
  data() {
    return {
      isSimulate: '',
      version: version,
      phone: '',
      username: '',
      timebaoStatus: 0,
      financeStatus: 0,
      holidayStatus: 0,
      time: '',
      haveRedEnvelope:0,
      user_suspect: false,
    }
  },
  watch: {
    '$route.path'(newPath) {
        if (newPath === '/myaccount/risk_control') {
            this.changeAccount(2);
        }
    }
    // isSimulate(newV, oldV) {
    //   if (newV) {
    //     //call simulate login and get token
    //     this.simulateLogin();
    //   } else {
    //     //normal account login not found so logout and redirect to login
    //     if (sessionStorage.getItem('token') == null) {
    //       this.exitLogin();
    //     } else {
    //       localStorage.setItem('isSimulation', false);
    //       window.location.reload();
    //     }
    //   }
    // }
  },
  components: {
  },
  mounted() {
    this.isSimulate = localStorage.getItem('isSimulation');
    this.isLogin();
    this.getUserinfo();
    this.getUserDetails();
    if (this.$route.path === '/myaccount/risk_control') {
        this.changeAccount(2);
    }
  },
  methods: {
    exitLogin() {
      this.$store.state.loginType = false;
      sessionStorage.removeItem("token");
      sessionStorage.removeItem("simulateToken");
      sessionStorage.removeItem("loginType");
      sessionStorage.removeItem("couponCheck");
      this.$router.push({
        path: "/login",
      });
    },
    isLogin() {
      if (!this.$store.state.loginType) {
        this.$router.push({
          path: "/login"
        });
      }
    },
    changeAccount(type) {
      window.sessionStorage.setItem("accountType", type);
      this.$store.state.accountType = type;
      if (type == 11) {
        window.location.reload();
        this.$router.push({
          path: "/myaccount/agency"
        });
      }
      else if(type == 16){
        let that = this;
       that
         .$http({
          url: "/app/Recharge/gxpay_thirdparty_digital_currency",
          method: "POST",
          data: {},
         })
         .then((ret) => {
           let resData = ret.data;
           if (resData.status == 1) {
            if(resData.data.user == true){
              this.$router.push("/myaccount/gxpay");
 
            }
           else{
           window.open(resData.data.homeUrl,'_blank');
           this.$store.state.accountType = 1;
           this.$router.push("/myaccount/rechange");

           }

           }
         });
      }
    },
    simulateLogin() {
      let that = this;
      that
        .$http({
          url: "/app/UserSimulate/login",
          method: "post",
          data: {

          },
          transformRequest: [(data) => JSON.stringify(data)]
        })
        .then(function (res) {
          if (res.data.status == 200) {
            window.sessionStorage.setItem("simulateToken", res.data.data.token);
            localStorage.setItem('isSimulation', true);
            // window.location.reload();
            that.$router.push({
                path: "/myaccount"
              });
          } else {
            that.$message.error(that.$t(res.data.msgId));
          }
        });
    },
    getUserinfo() {
      let that = this;
      that
        .$http({
          url: "/app/User/user",
          method: "post",
          data: {

          },
          transformRequest: [(data) => JSON.stringify(data)]
        })
        .then(function (res) {
          if (res.data.status == 200) {
            that.phone = res.data.data.phone;
            that.time = res.data.data.time;
            that.timebaoStatus = res.data.data.timebao_status;
            that.financeStatus = res.data.data.finance_status;
            that.holidayStatus = res.data.data.holiday_status;
            that.isSimulate = res.data.data.is_simulate;
            that.user_suspect = res.data.data.user_suspect;
          } else {
            that.$message.error(that.$t(res.data.msgId));
          }
        });
    },
    getUserDetails() {
      let that = this;
      that
        .$http({
          url: "/app/User/user_info",
          method: "post",
          data: {

          },
          transformRequest: [(data) => JSON.stringify(data)]
        })
        .then(function (res) {
          if (res.data.status == 200) {
            that.username = res.data.data.username;
            that.haveRedEnvelope=res.data.data.haveRedEnvelop==true?1:0;
            localStorage.setItem("username", that.username);
          } else {
            that.$message.error(that.$t(res.data.msgId));
          }
        });
    },
  }
};
</script>
<style scoped>
@import url("./../assets/css/account.css");
@import url("./../assets/css/deal.css");
* {
  font-family: "Helvetica Neue", Helvetica, "PingFang SC", "Hiragino Sans GB",
    "Microsoft YaHei", "微软雅黑", Arial, sans-serif;
}
.header_wrapper {
  height: 100px;
  width: 100%;
  background-color: var(--baseColor);
  margin-bottom: 10px;
}
.header_info {
  min-width: 1000px;
  max-width: 1200px;
  margin: 0 auto;
  height: 100%;
}
.portrait {
  margin-top: 10px;
  border-radius: 8px;
}
.header_right {
  color: white;
  height: 100px;
}
.line {
  display: block;
  width: 100%;
  height: 1px;
  background: url(../assets/img/line.png) no-repeat;
}
.center-nickname {
  font-size: 18px;
  /* padding-bottom: 10px; */
  padding-top: 20px;
}
.last-time {
  padding-top: 10px;
  font-size: 12px;
  color: #58616b;
  text-align: center;
}
.content-flex {
  display: flex;
  justify-content: center;
  flex-direction: column;
}
.basicInfo-box {
  background-color: #ffffff;
  border-radius: 8px !important;
  display: flex;
  flex-direction: column;
  align-items: center;
  padding: 20px 10px;
  margin-bottom: 20px;
}
.nav-tabs {
  background-color: #ffffff;
  border-radius: 8px;
  padding: 20px;
}
</style>




// WEBPACK FOOTER //
// src/components/myaccount.vue